import { render, staticRenderFns } from "./DeveloperPortal.vue?vue&type=template&id=ea0a287c&scoped=true"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js"
import style0 from "./DeveloperPortal.vue?vue&type=style&index=0&id=ea0a287c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0a287c",
  null
  
)

export default component.exports